import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import ArticleCard from "@/components/feature/ArticleCard";
import SEOHelmet from "@/components/feature/SEOHelmet";
import JsonLd from "@/components/feature/JsonLd";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function Home() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 5);
  const latestArticles = articles.slice(0, 6);
  const trendingSidebar = articles.slice(0, 8);

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "黑料bu打烊",
    url: "https://whxinantec.cn",
    description:
      "全网最全明星艺人黑料聚合平台，7×24小时不间断更新娱乐圈黑料、瓜事爆料、劲爆内幕。",
    inLanguage: "zh-CN",
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑料bu打烊",
    url: "https://whxinantec.cn",
    description:
      "全网最全明星艺人黑料聚合平台",
    contactPoint: {
      "@type": "ContactPoint",
      email: "contact@whxinantec.cn",
      contactType: "customer service",
    },
  };

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "黑料bu打烊 - 首页",
    description:
      "黑料bu打烊，全网最全明星艺人黑料聚合平台，7×24小时不间断更新娱乐圈黑料、瓜事爆料、劲爆内幕。",
    url: "https://whxinantec.cn",
    isPartOf: {
      "@type": "WebSite",
      name: "黑料bu打烊",
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHelmet
        title="黑料bu打烊 | 明星八卦黑料不打烊聚合平台 - 全网最全明星艺人黑料"
        description="黑料bu打烊，全网最全明星艺人黑料聚合平台，7×24小时不间断更新娱乐圈黑料、瓜事爆料、劲爆内幕。想看真实黑料就来黑料bu打烊，独家资讯一网打尽，随时随地吃瓜不断。"
        keywords="黑料bu打烊,黑料不打烊最新爆料,明星黑料聚合,娱乐圈黑料内幕,吃瓜黑料平台,艺人劲爆黑料,黑料爆料网站"
        canonicalUrl="https://whxinantec.cn"
      />
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <JsonLd data={webpageSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=dramatic%20dark%20stage%20with%20red%20velvet%20curtains%20and%20spotlights%2C%20mysterious%20theater%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20amber%20and%20crimson%20tones%2C%20empty%20center%20stage%20with%20dramatic%20shadows%2C%20luxurious%20theater%20interior%2C%20high%20contrast%20dramatic%20composition&width=1600&height=900&seq=hero-bg-main-2026&orientation=landscape"
              alt="黑料bu打烊 - 明星八卦黑料聚合平台"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
              <div className="w-full max-w-3xl">
                <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
                  黑料不打烊，吃瓜不间断
                </h1>
                <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
                  全网最全明星艺人黑料聚合平台，7×24小时不间断更新娱乐圈黑料、瓜事爆料、劲爆内幕。独家资讯一网打尽，随时随地吃瓜不断。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/zuixin-baoliao"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                  >
                    <i className="ri-flashlight-line"></i>
                    立即吃瓜
                  </Link>
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/30 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                  >
                    了解更多
                  </Link>
                </div>
              </div>
            </div>
          </section>

          {/* Hot Articles Section */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-fire-line text-primary-600 text-sm"></i>
                </div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  热门爆料
                </h2>
              </div>

              {/* Featured article */}
              {hotArticles.length > 0 && (
                <div className="mb-8">
                  <ArticleCard article={hotArticles[0]} variant="featured" />
                </div>
              )}

              {/* Hot article grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {hotArticles.slice(1).map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* Categories Section */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
                  分类吃瓜
                </h2>
                <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                  按分类浏览你最感兴趣的八卦内容，从明星黑料到综艺内幕，一网打尽
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors">
                      <i className={`${cat.icon} text-accent-600 text-lg`}></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Latest + Sidebar */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-8">
                {/* Main content */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-8">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                      <i className="ri-timer-flash-line text-accent-600 text-sm"></i>
                    </div>
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                      最新爆料
                    </h2>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    {latestArticles.map((article) => (
                      <ArticleCard key={article.id} article={article} />
                    ))}
                  </div>
                  <div className="mt-8 text-center">
                    <Link
                      to="/category/zuixin-baoliao"
                      className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                    >
                      查看更多爆料
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>

                {/* Sidebar */}
                <aside className="w-full lg:w-80 flex-shrink-0">
                  <div className="sticky top-20">
                    <div className="bg-background-100 rounded-lg p-5 mb-6">
                      <h3 className="text-base font-heading font-semibold text-foreground-900 mb-4 flex items-center gap-2">
                        <i className="ri-bar-chart-line text-accent-600"></i>
                        24小时热榜
                      </h3>
                      <div>
                        {trendingSidebar.map((article, index) => (
                          <ArticleCard
                            key={article.id}
                            article={article}
                            variant="compact"
                          />
                        ))}
                      </div>
                    </div>

                    <div className="bg-background-100 rounded-lg p-5">
                      <h3 className="text-base font-heading font-semibold text-foreground-900 mb-3 flex items-center gap-2">
                        <i className="ri-mail-send-line text-primary-600"></i>
                        爆料投稿
                      </h3>
                      <p className="text-sm text-foreground-600 mb-4 leading-relaxed">
                        你有独家黑料？欢迎向我们投稿，一经采用即付丰厚稿酬！
                      </p>
                      <a
                        href="mailto:tips@whxinantec.cn"
                        className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm w-full justify-center"
                      >
                        <i className="ri-send-plane-line"></i>
                        立即投稿
                      </a>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </section>

          {/* Stats Section */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-950">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-2">
                    15,000+
                  </div>
                  <p className="text-sm text-background-300">独家爆料</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-2">
                    500万+
                  </div>
                  <p className="text-sm text-background-300">月活跃用户</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-2">
                    98%
                  </div>
                  <p className="text-sm text-background-300">用户好评率</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-2">
                    7×24h
                  </div>
                  <p className="text-sm text-background-300">不间断更新</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}